"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OPTIONS = exports.MPP = exports.TILE_MODE = exports.IMAGE_TYPES = void 0;
const IMAGE_TYPES = {
  THUMBNAIL: -1,
  LABEL: -2,
  MACRO_CAMERA_IMAGE: -3,
  CLEARED_THUMBNAIL: -4
};
exports.IMAGE_TYPES = IMAGE_TYPES;
const TILE_MODE = {
  STATIC: 'S',
  PROGRESSIVE: 'P'
};
exports.TILE_MODE = TILE_MODE;
const BASELINE_MPP = 0.5;
const BASELINE_MPP_RANGE = 0.05;
const MPP = {
  BASELINE: BASELINE_MPP,
  BASELINE_RANGE: 0.05,
  BASELINE_MIN: BASELINE_MPP - BASELINE_MPP_RANGE,
  BASELINE_MAX: BASELINE_MPP + BASELINE_MPP_RANGE
};
/*
 * {int}     top     - X-coordinate of region, in pixels (upper left is [0,0]). Default is 0.
 * {int}     left    - Y-coordinate of region, in pixels (upper left is [0,0]). Default is 0.
 * {int}     width   - width of region, in pixels. Maximum width is 2000 pixels. Default is image width or 2000, whichever is less.
 * {int}     height  - height of region, in pixels. Maximum height is 2000 pixels. Default is image height or 2000, whichever is less.
 * {float}   zoom    - zoom level of region (float), .5 = 200%, 2 = 50%, 4 = 25%. Other special values: -1 = thumbnail image -2 = label image (if any) -3 = macro camera image (if any) The default value for zoom is 1 (= 100%)
 * {int}     quality - JPEG quality level, (1-100). A level of 75 approximately corresponds to the JPEG2000 image quality. Default is 75.
 * {string}  mode    - JPEG mode. If specified as S images will be static (non-progressive). Default is progressive (P). {Ordinarily progressive mode is “better” however some software cannot handle progressive JPEGs, notably Macromedia Flash.}
 * {int}     focus   - focus value for region (float), in range -1 -> +1 (with 0 at “center”). Default is 0.
 * {int}     cachebust - ("random" in docs) Cachebusting mechanism. Optional and no default.
 * {float}   mpp     - microns per pixel. Should be 0.5 +/- 0.05
 */

exports.MPP = MPP;
const DEFAULT_OPTIONS = {
  top: 0,
  left: 0,
  width: 512,
  height: 512,
  zoom: 1,
  quality: 75,
  mode: TILE_MODE.PROGRESSIVE,
  focus: 1,
  cachebust: 0,
  mpp: 0.5025
};
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;